

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.bXHAzYqq.js","_app/immutable/chunks/disclose-version.DQqMciGL.js","_app/immutable/chunks/runtime.4tlg2WhF.js","_app/immutable/chunks/legacy.BTby3Cl7.js","_app/immutable/chunks/render.C03RQbLD.js","_app/immutable/chunks/lifecycle.CjAMxTXn.js","_app/immutable/chunks/entry.CGF1h43z.js","_app/immutable/chunks/index-client.DZ3evCgP.js"];
export const stylesheets = [];
export const fonts = [];
